"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTENT_ROOT = void 0;
const CONTENT_ROOT = exports.CONTENT_ROOT = 'content-root';
